import { IGoal } from 'motw_core/Entity/IGoal';
import { PopulateLogStateFromGoal } from 'source/app/presentation/MainPanel/Goals/GoalCards/Helpers/PopulateLogStateFromGoal';

export const ClickGoal = (goal: IGoal) => {
	PopulateLogStateFromGoal(goal);
	const logInputEntryTextElement = document.getElementById('LogInpEntryText');
	
	if (logInputEntryTextElement) {
		logInputEntryTextElement.focus();
	}
};
